export const ifThen = (antecedent, consequent) => !antecedent || consequent;
